import { makeEntityScaffold } from '@classpass/saga-tools';
import _get from 'lodash/get';
import _hasIn from 'lodash/hasIn';
import _isEmpty from 'lodash/isEmpty';

import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';

import URLS from 'constants/urls';

const get = client => {
  const endpoint = URLS.staffAccounts.get;

  return client.get(endpoint).then(({ data }) => _get(transformKeysToCamelCase(data), 'data.dashboardUsers'));
};

const post = (client, account) => {
  const endpoint = URLS.staffAccounts.create;

  return client
    .post(endpoint, transformKeysToSnakeCase(account))
    .then(response => transformKeysToCamelCase(response.data));
};

const put = (client, account) => {
  const { userId, ...restAccount } = account;
  const endpoint = URLS.staffAccounts.update(userId);

  return client
    .put(endpoint, transformKeysToSnakeCase(restAccount))
    .then(response => transformKeysToCamelCase(response.data));
};

const handler = ({ httpClient }, account) => {
  if (!_isEmpty(account)) {
    if (_hasIn(account, 'userId')) return put(httpClient, account);

    return post(httpClient, account);
  }

  return get(httpClient);
};

export default makeEntityScaffold('SAGA.API.STAFF_ACCOUNTS', handler, { defaultKey: 1 });
